import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { CompanyAdminModel } from './companyAdmin.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class CompanyAdminService {
    constructor(private authService: AuthService, private http: Http) { }

    public GetCompanyAdminList(companyMasterHashID: string, input?: DataListModel): Observable<IAPIResponse> {
        let getComapanyAdminUrl = WeGoConfig.API_GET_COMPANY_ADMIN_LIST;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getComapanyAdminUrl = getComapanyAdminUrl + "?" + queryString + "&companyHashID=" + companyMasterHashID;
        }
        else {
            getComapanyAdminUrl = getComapanyAdminUrl + "?companyHashID=" + companyMasterHashID;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getComapanyAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ExportCompanyAdminList(companyMasterHashID: string, input?: DataListModel): any {
        input.currentPage = 0;
        let queryString = this.authService.HandleAPIListInput(input);
        let getCompanyAdminUrl = WeGoConfig.API_EXPORT_COMPANY_ADMIN_LIST + "?" + queryString + "&companyHashID=" + companyMasterHashID;
        let headers = this.authService.GetHeader('text/csv');
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getCompanyAdminUrl, options);
    }

    public GetPersonListByCompanyId(pageNo: number, searchField: string, searchTerm: string, companyMasterHashId: string): Observable<IAPIResponse> {
        let getPersonUrl = WeGoConfig.API_GET_PERSON_LIST_BY_COMPANY_ID + "?pageNo=" + pageNo + "&record=" + WeGoConfig.GRID_MAX_DATA_SIZE + "&searchField=" + searchField + "&searchTerm=" + searchTerm + "&companyMasterHashId=" + companyMasterHashId;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getPersonUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public AddNewCompanyAdmin(companyAdminModel: CompanyAdminModel): Observable<IAPIResponse> {
        let body = companyAdminModel;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });

        return this.http.post(WeGoConfig.API_POST_COMPANY_ADMIN_DETAIL, body, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteCompanyAdmin(selectedCompanyAdminList: string[]): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });

        return this.http.post(WeGoConfig.API_POST_DELETE_COMPANY_ADMIN, selectedCompanyAdminList, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/company-admin/models/companyAdmin.service.ts